import React from "react";
import Checkbox from "material-ui/Checkbox";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { reduxForm } from "redux-form";
import { connect } from "react-redux";
import MediosElectronicos from "./mediosElectronicos.cmpt";
import AvisoSimplificado from "./avisoSimplificado.cmpt";
const iconWarning = require("../img/icono_warning.svg");

const modalAyuda = "#modal-ayuda-registro";

const mapState = (state) => {
  return {
    dispositivo: state.global.dispositivo,
  };
};

const mapDispatch = (dispatch) => {
  return {
    aviso: (sMensaje) => {
      dispatch({
        type: "MODAL_ALERT_MESSAGES_SHOW",
        titulo: "Aviso de privacidad.",
        mensaje: sMensaje,
      });
    },
    avisoPrivacidad: (showAviso) => {
      dispatch({ type: "AVISO_PRIVACIDAD", showAviso: showAviso });
    },
    avisoTerminos: (showAviso) => {
      dispatch({ type: "AVISO_TERMINOS", showAviso: showAviso });
    },
    tagManager: (oDataTagManager) => {
      dispatch(oDataTagManager);
    },
  };
};

class AvisoPrivacidad extends React.Component {
  state = {
    avisoAceptado: false,
    mediosElectronicos: false,
    habilitaBtnAviso: true,
  };

  checkAvisos = () => {
    if (
      aceptarAviso.checked === true &&
      mediosElectronicos.checked === true
    ) {
      this.props.handler(true);
      localStorage.setItem("aceptarAviso", true);
      localStorage.setItem("mediosElectronicos", true);
      this.props.tagManager({
        type: "ACEPTO_AVISO_PRIVACIDAD",
        dispositivo: this.props.dispositivo,
      });
      this.setState({ avisoAceptado: true });
      this.props.change("avisoAceptado", true);
  
      this.props.tagManager({
        type: "ACEPTO_MEDIOS_ELECTRONICOS",
        dispositivo: this.props.dispositivo,
      });
  
      this.setState({ mediosElectronicos: true });
      this.props.change("mediosElectronicos", true);
    } else {
      this.props.handler(false);
    }
  };

  showModal = () => {
    $("#modal-terminos-condiciones").modal({
      backdrop: "static",
      keyboard: false,
    });
  };

  showModalSimplificado = () => {
    $("#modal-aviso-simplificado").modal({
      backdrop: "static",
      keyboard: false,
    });
  };

  openAvisoSimplificado = () => {
    window.open("https://www.gnp.com.mx/aviso-de-privacidad/integral", "_blank");
  }

  onClose = e => { 
    this.props.onClose && this.props.onClose (e); 
    $(modalAyuda).modal("hide");
  };

  render() {
    return ( //NOSONAR
      <div>
        <div className="containerAvisos">
          <div style={{ display:"flex", width: "100%" }}>
            <MuiThemeProvider>
              <Checkbox
                id="aceptarAviso"
                name="aceptarAviso"
                value="aviso"
                onChange={this.checkAvisos}
                onClick={this.checkAvisos}
                style={{width: "auto !important"}}
                iconStyle={{ color: "#0C2040 !important", fill: "#FF6B0B" }}
              />
            </MuiThemeProvider>
            <p className="avisoPrivacidad-type-txt" style={{color: this.props.showError ? "#611616" : null}}>
              Conozco, entiendo y consiento que mis datos personales serán tratados conforme al&nbsp;
              <span
                className="avisoPrivacidad-type-txt"
                id="terminosCondiciones-2"
                style={{ marginLeft: "1px", marginRight: "1px" }}
                onClick={this.openAvisoSimplificado}
              >
                Aviso de privacidad Integral
              </span>
              &nbsp;de Grupo Nacional Provincial S.A.B
            </p>
          </div>
          
          <div style={{ display:"flex", width: "100%" }}>
            <MuiThemeProvider>
              <Checkbox
                id="mediosElectronicos"
                name="mediosElectronicos"
                value="mediosElectronicos"
                onChange={this.checkAvisos}
                onClick={this.checkAvisos}
                style={{width: "auto !important"}}
                iconStyle={{ color: "#0C2040 !important", fill: "#FF6B0B" }}
              />
            </MuiThemeProvider>
              <p className="avisoPrivacidad-type-txt" style={{color: this.props.showError ? "#611616" : null}}>
                He leído y acepto los&nbsp;
              <span
                className="avisoPrivacidad-type-txt"
                id="terminosCondiciones-2"
                style={{ marginLeft: "1px", marginRight: "1px" }}
                onClick={this.showModal}
              >
                Términos y condiciones de uso de Medios Electrónicos
              </span>
                &nbsp;de Grupo Nacional Provincial S.A.B
              </p>
          </div>

          {this.props.showError &&
            <div style={{ display:"flex", width: "100%" }}>
              <img src={iconWarning} />
              <label className="avisosWarning">Estas opciones son obligatorias</label>
            </div>
          }
        </div>

        <div
          className="modal fade modal-msj"
          id="modal-terminos-condiciones"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-terminos-condiciones"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            className="modal-dialog modal-terminos-responsive"
            role="document"
          >
            <div className="modal-content" id="div-body-modal" modal-type="medios">
              <MediosElectronicos></MediosElectronicos>
            </div>
          </div>
        </div>

        <div
          className="modal fade modal-msj"
          id="modal-aviso-simplificado"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-aviso-simplificado"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            className="modal-dialog modal-terminos-responsive"
            role="document"
          >
            <div className="modal-content" id="div-body-modal" modal-type="simplificado">
              <AvisoSimplificado></AvisoSimplificado>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AvisoPrivacidad = reduxForm({ form: "datos-poliza" })(AvisoPrivacidad);
export default connect(mapState, mapDispatch)(AvisoPrivacidad);



// WEBPACK FOOTER //
// ./src/gnp-registro/avisoPrivacidad.cmpt.js